import {Injectable, inject, DestroyRef} from '@angular/core';
import { DeviceInfo, DevicePort } from '../../../../../shared/domain/ports/device.port';
import { DeviceService } from '../../device.service';
import { map, Observable, catchError, of } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Device } from '../../models/device.model';

@Injectable({ providedIn: 'root' })
export class DeviceAdapter implements DevicePort {
  private readonly deviceService = inject(DeviceService);
  private readonly destroyRef = inject(DestroyRef);

  getDeviceInfo(): DeviceInfo | null {
    const device: Device | null = this.deviceService.device;

    return this.mapDevice(device);
  }

  getDeviceInfoAsync(): Observable<DeviceInfo | null> {
    return this.deviceService.getDevice().pipe(
      map((device: Device | null) => this.mapDevice(device)),
      catchError(() => of(null)),
      takeUntilDestroyed(this.destroyRef)
    );
  }

  private mapDevice(device: Device | null): DeviceInfo | null {
    if (!device?._id || !device.name) {
      return null;
    }

    return {
      id: device._id,
      name: device.name,
      isPersonal: device.personal_use,
    };
  }
}
